import * as BABYLON from "babylonjs"
import * as GUI from "babylonjs-gui"
import { Global } from "../../classes/global"

export class ParentPlane {
	static mesh: BABYLON.Mesh | null = null
	static _size: [number, number]
	static _scene: BABYLON.Scene

	static create(
		scene: BABYLON.Scene,
		id: string,
		position: [number, number, number],
		size: [number, number],
		hexColour: string,
		accentColour: string,
		grabbable: boolean = true,
		visibility: boolean = false,
		parentID?: string
	): BABYLON.Mesh {
		ParentPlane._scene = scene
		ParentPlane._size = size
		ParentPlane.mesh = BABYLON.MeshBuilder.CreatePlane(
			id,
			{ width: ParentPlane._size[0], height: ParentPlane._size[1] },
			scene
		)
		ParentPlane.mesh.position = new BABYLON.Vector3(
			position[0],
			position[1],
			position[2]
		)

		//parentPlane.rotation.x = Math.PI

		const advancedTexture = GUI.AdvancedDynamicTexture.CreateForMesh(
			ParentPlane.mesh,
			1024,
			1024
		)

		const planeBlock = new GUI.Rectangle()
		planeBlock.width = "100%"
		planeBlock.height = "100%"
		planeBlock.background = hexColour
		planeBlock.cornerRadius = 20
		advancedTexture.addControl(planeBlock)

		if (parentID) {
			const parentMesh = ParentPlane.mesh._scene!.getMeshByID(
				parentID
			) as BABYLON.Mesh
			if (parentMesh) {
				ParentPlane.mesh.parent = parentMesh
			}
		}

		// Enable interaction with the dial
		ParentPlane.mesh.actionManager = new BABYLON.ActionManager(scene)
		const dragBehavior = new BABYLON.SixDofDragBehavior()
		//let canDrag = true

		if (grabbable) {
			// Add behavior but control its activation through a flag
			ParentPlane.mesh.addBehavior(dragBehavior)
			scene.onPointerObservable.add((pointerInfo) => {
				if (pointerInfo.type === BABYLON.PointerEventTypes.POINTERMOVE) {
					const pickedMesh = scene.pick(
						scene.pointerX,
						scene.pointerY
					).pickedMesh
					if (pickedMesh != null && pickedMesh.parent != null) {
						if (
							pickedMesh!.parent!.name == "UI_parent" ||
							pickedMesh!.parent!.name == "UI_parent1"
						) {
							Global.canDrag = false
						} else {
							Global.canDrag = true
						}
					} else if (pickedMesh != null && pickedMesh!.parent == null) {
						Global.canDrag = true
					}
				}
			})

			if (ParentPlane.mesh.name == "UI_parent") {
				Global.parentPlaneDragBehaviour = dragBehavior
				Global.parentPlaneBlock = planeBlock
			} else if (ParentPlane.mesh.name == "UI_parent1") {
				Global.parentPlaneDragBehaviour1 = dragBehavior
				Global.parentPlaneBlock1 = planeBlock
			}
			Global.parentBlockHighlightColour = accentColour
			// Modify the drag behavior's start condition
			dragBehavior.onDragStartObservable.add(() => {
				if (Global.canDrag) {
					console.log("candrag")
					//canDrag = false
					planeBlock.thickness = 6 // Border thickness
					planeBlock.color = accentColour // Border color
					dragBehavior.disableMovement = false
				}
			})

			// Optionally, you can reset the flag on drag end if necessary
			dragBehavior.onDragEndObservable.add(() => {
				planeBlock.thickness = 0 // Reset thickness to remove the border
				dragBehavior.disableMovement = true
			})
		}

		ParentPlane.mesh.isVisible = visibility
		//parentPlane.renderingGroupId = 1

		return ParentPlane.mesh
	}

	static sliderChangeSize(value: number) {
		var parentMesh = ParentPlane._scene.getMeshByID("UI_parent")
		var parentMesh1 = ParentPlane._scene.getMeshByID("UI_parent1")
		const inMin: number = 0
		const inMax: number = 100
		const outMin: number = 0.1
		const outMax: number = 2
		const conversionValue =
			((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin
		parentMesh!.scaling.x = conversionValue
		parentMesh!.scaling.y = conversionValue
		parentMesh1!.scaling.x = conversionValue
		parentMesh1!.scaling.y = conversionValue
	}
	static sliderChangeOpacity(value: number) {
		var parentMesh = ParentPlane._scene.getMeshByID("UI_parent")
		var parentMesh1 = ParentPlane._scene.getMeshByID("UI_parent1")
		const inMin: number = 0
		const inMax: number = 100
		const outMin: number = 0.1
		const outMax: number = 1
		const conversionValue =
			((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin
		if (parentMesh && parentMesh.getChildMeshes()) {
			parentMesh!.material!.alpha = conversionValue
		}
		if (parentMesh1 && parentMesh1.getChildMeshes()) {
			parentMesh1!.material!.alpha = conversionValue
		}
	}

	// Exposing the function globally for demonstration; replace with your preferred way of making it accessible externally
}
